import { Route, Routes } from 'react-router-dom';
import { ExpertHubLayout } from 'components/templates';
import WalletOverView from './components/wallet-overview';

const wallet = () => (
  <ExpertHubLayout>
    <Routes>
      <Route path="/" element={<WalletOverView />} />
    </Routes>
  </ExpertHubLayout>
);

export default wallet;
